export let CouponType = /*#__PURE__*/function (CouponType) {
  CouponType["MoneyOff"] = "MoneyOff";
  CouponType["PercentOff"] = "PercentOff";
  CouponType["FreeShipping"] = "FreeShipping";
  CouponType["FixedPrice"] = "FixedPrice";
  CouponType["BuyXGetY"] = "BuyXGetY";
  return CouponType;
}({});
//# sourceMappingURL=ICoupon.js.map